var setServerUrl = function() {
    var currentScript = '';

///////////////////////
////////////////////////////////////

/////////////
//////////////////////////////////////////////////////
///////////////////////////////////
//////////////////////////////////////////////////////////////////
/////////
/////////////////////
////////////////////////////////////////////////
/////////////////////
/////////////////////////////////////////////////////////////////////////////////////

////////////
//////////////////////////////////////////////////////////////
/////
////////////
    currentScript = window.origin;
/////////////
}();

import ObservableSubject from "App/observable_subject";
import * as math from "./math";
import StateViewer from "./state_viewer";

import AnimatedObject from "./animations/animated_object";
import CameraAnimator from "./animations/camera_animator";

import Interpolator from "./animations/interpolators/interpolator";
import LinearInterpolator from "./animations/interpolators/linear";
import Quaternion from "./animations/interpolators/quaternion";
import TimeLoop from "./animations/interpolators/time_loop";
import InterpolatorsFactory from "./animations/interpolators/factory";

import {ImageManager} from "./environment/managers/image_manager";
import ManipulatorManager from "./environment/managers/manipulator_manager";

import {Tools} from "./environment/tools";
import MovableObject from "./environment/movable_object";
import DrawableObject from "./environment/drawable_object";
import Arrow from "./environment/objects/arrow";
import ArrowNarrow from "./environment/objects/arrow_narrow";
import Circle from "./environment/objects/circle";
import Plane from "./environment/objects/plane";
import Plane2 from "./environment/objects/plane2";
import Cube from "./environment/objects/cube";
import Grass from "./environment/objects/grass";
import LetterX from "./environment/objects/letter_x";
import LetterY from "./environment/objects/letter_y";
import LetterZ from "./environment/objects/letter_z";

import WebGLContext from "./web_gl_context";
import Canvas2DContext from "./canvas_2d_context";
import Renderer from "./renderer";
import RenderDocument from "./render_document";
import Model from "./model";
import Asset from "./asset";
import MemoryManagement from "./memory_management";

import {Zeropoint} from "./zero_point";
import Appearance from "./geometry/material/appearance";
import MaterialFactory from "./geometry/material/factory";
import AbstractMaterial from "./geometry/material/abstract_material";
import SurfaceColor from "./geometry/material/surface_color";
import RenderOption from "./geometry/material/render_option";
import PointProperties from "./geometry/material/point_properties";
import LineProperties from "./geometry/material/line_properties";
import {Texture, EDataTypeType} from "./geometry/material/texture";
import MaterialLibrary from "./geometry/material/material_library";
import RayIntersector from "./geometry/intersectors/ray_intersector";
import NodesFactory from "./render/webgl/nodes/factory";
import RenderNode from "./render/webgl/nodes/render_node";
import ShapeBatchNode from "./render/webgl/nodes/shape_batch_node";
import RenderablesFactory from "./render/webgl/renderables/factory";
import Renderable from "./render/webgl/renderables/renderable";
import Material from "./render/webgl/renderables/material";
import Shader from "./render/webgl/renderables/shader";
import RenderableTexture from "./render/webgl/renderables/texture";
import RenderableRenderOption from "./render/webgl/renderables/renderable";
import LineRenderOption from "./render/webgl/renderables/line_render_option";
import PointRenderOption from "./render/webgl/renderables/point_render_option";
import Batch, {UPDATETYPES} from "./render/webgl/renderables/batches/batch";
import ShapeBatch from "./render/webgl/renderables/batches/shape_batch";
import PointBatch from "./render/webgl/renderables/batches/point_batch";
import ParticlesBatch from "./render/webgl/renderables/batches/particles_batch";
import LineBatch from "./render/webgl/renderables/batches/line_batch";
import OutlineBatch from "./render/webgl/renderables/batches/outline_batch";
import PointCloudBatch from "./render/webgl/renderables/batches/point_cloud_batch";
import SVSideShapeBatch from "./render/webgl/renderables/batches/sv_side_shape_batch";
import SVCapShapeBatch from "./render/webgl/renderables/batches/sv_cap_shape_batch";
import BillboardBatch from "./render/webgl/renderables/batches/billboard_batch";
import VolumetricShapeBatch from "./render/webgl/renderables/batches/volumetric_shape_batch";
import ObjectsFactory from "./geometry/objects/factory";
import RenderObject from "./geometry/objects/object";
import Shape from "./geometry/objects/shape";
import SVSideShape from "./geometry/objects/sv_side_shape";
import SVCapShape from "./geometry/objects/sv_cap_shape";
import Line from "./geometry/objects/line";
import Outline from "./geometry/objects/outline";
import POI from "./geometry/objects/poi";
import Point from "./geometry/objects/point";
import Text from "./geometry/objects/text";
import PointCloud from "./geometry/objects/point_cloud";
import Skybox from "./geometry/objects/skybox";
import SkyDome from "./geometry/objects/sky_dome";
import GroundPlane from "./geometry/objects/ground_plane";
import Particles from "./geometry/objects/particles";
import Text2d from "./geometry/objects/text_2d";
import ChunkLODNodeShape from "./geometry/objects/chunk_lod_node_shape";
import HUDShape from "./geometry/objects/hud_shape";
import Billboard from "./geometry/objects/billboard";
import GeoemtryObejctsFactory from "./geometry/objects_geometry/factory";
import AbstractGeometry from "./geometry/objects_geometry/abstract_geometry";
import Binary from "./geometry/objects_geometry/binary";
import LineBinary from "./geometry/objects_geometry/line_binary";
import IndexedLineSet from "./geometry/objects_geometry/indexed_line_set";
import TextOB from "./geometry/objects_geometry/text";
import PointSet from "./geometry/objects_geometry/point_set";
import ParticlesGO from "./geometry/objects_geometry/particles";
import PointCloudBinary from "./geometry/objects_geometry/point_cloud_binary";
import IndexedFaceSet from "./geometry/objects_geometry/indexed_face_set";
import OffsetedIndexedFaceSet from "./geometry/objects_geometry/offseted_indexed_face_set";
import VolumetricIndexedFaceSet from "./geometry/objects_geometry/volumetric_indexed_face_set";
import SVBinaryGeometry from "./geometry/objects_geometry/sv_binary_geometry";
import Description from "./geometry/description";
import VertexDataDescriptor from "./geometry/objects_geometry/vertex_data_descriptor";
import Serializer from "./model/serializer";
import ModelDescription from "./model/description";
import Parts from "./model/parts/parts";
import PartsPair from "./model/parts/parts_pair";
import PartsEntity from "./model/parts/parts_entity";
import Annotation from "./model/annotations/annotation";
import Annotations from "./model/annotations/annotations";
import CameraAnimation from "./model/animations/camera_animation";
import CameraAnimations from "./model/animations/camera_animations";
import Group from "./model/group";
import Configuration, {ConfigurationData} from "./model/configuration";
import LightingSettings, {LightingSettingsData} from "./model/lighting_settings";
import ProjectInfo from "./model/project_info";
import ZeropointSettings from "./model/zeropoint_settings";
import GeoLocationSettings from "./model/geo_location_settings";
import Standpoints from "./model/standpoints";
import Views from "./model/views";
import GroupTree from "./model/group_tree";
import {RenderElement, EPartsTypes} from "./model/elements/element";
import ExternalModel from "./model/elements/external_model";
import GlobeModel from "./model/elements/globe_model";
import GeometryEntityElement from "./model/elements/geometry_entity_element";
import Octree from "./model/elements/octree";
import ChunkLODNode from "./model/elements/chunk_lod_node_element";
import Elements from "./model/elements/elements";
import {Factory as FactoryElements} from "./model/elements/factory";
import DrawStyle from "./model/draw_style";
import DrawSettings from "./model/draw_settings";
import View from "./view/view";
import ViewVR from "./view/view_vr";
import ViewStereo from "./view/view_stereo";
import ViewWebVR from "./view/view_web_vr";
import Hud from "./view/hud";
import ViewMode from "./view/modes/view_mode";
import ViewModeSingle from "./view/modes/view_mode_single";
import ViewModeQuad from "./view/modes/view_mode_quad";
import ViewModeStereo from "./view/modes/view_mode_stereo";
import ViewModeWebVR from "./view/modes/view_mode_web_vr";
import ViewControls from "./view/controls/view_controls";
import ExaminerControls from "./view/controls/examiner_controls";
import ExaminerControlsStereo from "./view/controls/examiner_controls_stereo";
import ExaminerControlsVR from "./view/controls/examiner_controls_vr";
import WalkControls from "./view/controls/walk_controls";
import WalkControlsStereo from "./view/controls/walk_controls_stereo";
import WalkControlsVR from "./view/controls/walk_controls_vr";
import FlyControls from "./view/controls/fly_controls";
import FlyControlsStereo from "./view/controls/fly_controls_stereo";
import FlyControlsVR from "./view/controls/fly_controls_vr";
import FileAnimationControls from "./view/controls/file_animation_controls";
import FileAnimationControlsStereo from "./view/controls/file_animation_controls_stereo";
import FileAnimationControlsWebVR from "./view/controls/file_animation_controls_web_vr";
import Camera from "./view/cameras/camera";
import CameraVR from "./view/cameras/camera_vr";
import CameraStereo from "./view/cameras/camera_stereo";
import CameraWebVR from "./view/cameras/camera_web_vr";
import Light from "./view/lights/light";
import DirectionalLight from "./view/lights/directional_light";
import HeadLight from "./view/lights/head_light";
import SunLight from "./view/lights/sun_light";
import Shape2D from "./utils/text/fonts/shape_2d";
import PathToShape2D from "./utils/text/fonts/path_to_shape_2d";
import * as PointUtil from "./utils/text/fonts/point_util";
import {triangulate} from "./utils/text/fonts/shape_2d_triangulate";
import FontCache from "./utils/text/fonts/font_cache";
import CanvasTextGenerator from "./utils/text/canvas_text_generator";
import CanvasTextureDictionary from "./utils/text/canvas_texture_dictionary";
import TexturesManager from "./utils/textures/textures_manager";
import ResolveResolutionWorkerManager from "./utils/textures/resolve_resolution_worker_manager";
import CrunchDecodeWorkerManager from "./utils/textures/crunch_decode_worker_manager";
import ImageDataParser from "./utils/textures/image_data_parser";
import ImageDataLoadersFactory from "./utils/textures/image_data_loaders_factory";
import ImageDataLoader from "./utils/textures/image_data_loader";
import CRNImageLoader from "./utils/textures/crn_image_loader";
import DDSImageLoader from "./utils/textures/dds_image_loader";
import DOMImageLoader from "./utils/textures/dom_image_loader";
import ETC1ImageLoader from "./utils/textures/etc1_image_loader";
import PVRImageLoader from "./utils/textures/pvr_image_loader";
import TextureDataHandler from "./utils/textures/texture_data_handler";
import ProgressDispatchHelper from "./utils/progress_dispatch_helper";
import {FakeWorker} from "./utils/fake_worker";
import {Framebuffer} from "./utils/frame_buffer";
import {WebglTimer} from "./utils/webgl_timer";
import Container from "./utils/container";
import { Factory as FactoryUtils} from "./utils/factory";
import * as Utils from "./utils/utils";
import * as GLU from "./utils/glu";
import {Ray} from "./utils/ray";
import {FrustumVolume} from "./utils/view_frustum";
import BoundingBox from "./utils/bounding_box";
import {Dms} from "./utils/projections/dms";
import {Vector3d} from "./utils/projections/vector_3d";
import {LatLon} from "./utils/projections/latlon-ellipsoidal";
import RenderState from "./render/webgl/render_state";
import BufferHandler from "./render/webgl/utils/buffer_handler";
import ArrayBufferHandler from "./render/webgl/utils/array_buffer_handler";
import MultiArrayBufferHandler from "./render/webgl/utils/multi_array_buffer_handler";
import ElementArrayBufferHandler from "./render/webgl/utils/element_array_buffer_handler";
import FullScreenQuad from "./render/webgl/utils/full_screen_quad";
import BatchesManagerNode from "./render/webgl/nodes/batches_manager_node";
import MaterialNode from "./render/webgl/nodes/material_node";
import TransformNode from "./render/webgl/nodes/transform_node";
import TextureNode from "./render/webgl/nodes/texture_node";
import RenderOptionNode from "./render/webgl/nodes/render_option_node";
import RenderBinNode from "./render/webgl/nodes/render_bin_node";
import BinsFactory from "./render/webgl/nodes/bins/factory";
import OpaqueBin from "./render/webgl/nodes/bins/opaque_bin";
import OpaqueNoTextureBin from "./render/webgl/nodes/bins/opaque_no_texture_bin";
import HUDBin from "./render/webgl/nodes/bins/hud_bin";
import NewHUDBin from "./render/webgl/nodes/bins/new_hud_bin";
import TextBin from "./render/webgl/nodes/bins/text_bin";
import TransparentBin from "./render/webgl/nodes/bins/transparent_bin";
import TransparentNoTextureBin from "./render/webgl/nodes/bins/transparent_no_texture_bin";
import TransparentInternalBin from "./render/webgl/nodes/bins/transparent_internal_bin";
import TransparentNoTextureInternalBin from "./render/webgl/nodes/bins/transparent_internal_no_texture_bin";
import LinesBin from "./render/webgl/nodes/bins/lines_bin";
import OutlinesBin from "./render/webgl/nodes/bins/outlines_bin";
import PointCloudsBin from "./render/webgl/nodes/bins/point_clouds_bin";
import PointsBin from "./render/webgl/nodes/bins/points_bin";
import PoiBin from "./render/webgl/nodes/bins/poi_bin";
import ParticlesBin from "./render/webgl/nodes/bins/particles_bin";
import AlphaTransparencyBin from "./render/webgl/nodes/bins/alpha_transparency_bin";
import BillboardBin from "./render/webgl/nodes/bins/billboard_bin";
import SkyBoxBin from "./render/webgl/nodes/bins/sky_box_bin";
import SkyDomeBin from "./render/webgl/nodes/bins/sky_dome_bin";
import ShadowVolumeBin from "./render/webgl/nodes/bins/shadow_volume_bin";
import ChunkLODBin from "./render/webgl/nodes/bins/chunk_lod_bin";
import CanvasBinFactory from "./render/canvas/nodes/bins/factory";
import Text2dCanvas from "./render/canvas/nodes/bins/text_2d";
import WebVRHUD from "./render/canvas/nodes/bins/web_vr_hud";
import {AbstractRenderGraph} from "./render/abstract_render_graph";
import RenderGraphLoadStatus from "./render/render_graph_load_status";
import RenderGraph from "./render/webgl/render_graph";
import ScreenFrameBuffer from "./render/webgl/utils/screen_frame_buffer";
import OffscreenFrameBuffer from "./render/webgl/utils/offscreen_frame_buffer";
import MRTFrameBuffer from "./render/webgl/utils/mrt_frame_buffer";
import {LinkedShapesList} from "./render/webgl/utils/linked_shapes_list";
import LinkedShapesListItem from "./render/webgl/utils/linked_shapes_list_item";
import PassesFactory from "./render/webgl/passes/factory";
import Pass from "./render/webgl/passes/pass";
import Controls from "./render/webgl/passes/controls";
import DepthLowRes from "./render/webgl/passes/depth_low_res";
import Depth from "./render/webgl/passes/depth";
import ObjectId from "./render/webgl/passes/object_id";
import OpaqueDepth from "./render/webgl/passes/opaque_depth";
import PrimitiveId from "./render/webgl/passes/primitive_id";
import FloorPlan from "./render/webgl/passes/floor_plan";
import Screen from "./render/webgl/passes/screen";
import ScreenAllOpaque from "./render/webgl/passes/screen_all_opaque";
import ScreenAllTransparent from "./render/webgl/passes/screen_all_transparent";
import ScreenWithShadowVolumes from "./render/webgl/passes/screen_with_shadow_volumes";
import HUD from "./render/webgl/passes/hud";
import WeightedAverage from "./render/webgl/passes/wavg/weighted_average";
import ColorAccumulation from "./render/webgl/passes/wavg/color_accumulation";
import DepthAccumulation from "./render/webgl/passes/wavg/depth_accumulation";
import ShadowMap from "./render/webgl/passes/shadow_map/shadow_map";
import ShadowMapPoisson from "./render/webgl/passes/shadow_map/shadow_map_poisson";
import ShadowMapVariance from "./render/webgl/passes/shadow_map_variance/shadow_map_variance";
import ShadowMapBlur from "./render/webgl/passes/shadow_map_variance/shadow_map_blur";
import AO from "./render/webgl/passes/ssao/ao";
import AOBlur from "./render/webgl/passes/ssao/ao_blur";
import AOGeometry from "./render/webgl/passes/ssao/ao_geometry";
import AONormals from "./render/webgl/passes/ssao/ao_normals";
import AOMRT from "./render/webgl/passes/ssao/ao_mrt";
import ShadersFactory from "./render/webgl/shaders/factory";
import ShaderShader from "./render/webgl/shaders/shader";
import LineShader from "./render/webgl/shaders/outline";
import OpaqueShader from "./render/webgl/shaders/opaque";
import OpaqueNoTextureShader from "./render/webgl/shaders/opaque_no_texture";
import AlphaTransparencyShader from  "./render/webgl/shaders/alpha_transparency";
import HUDAlphaTransparencyShader from  "./render/webgl/shaders/hud_alpha_transparency";
import BillboardShader from  "./render/webgl/shaders/billboard";
import GeomtextShader from  "./render/webgl/shaders/geomtext";
import OutlineShader from  "./render/webgl/shaders/outline";
import PointShader from  "./render/webgl/shaders/point";
import PointCloudShader from  "./render/webgl/shaders/point_cloud";
import SkyBoxShader from  "./render/webgl/shaders/sky_box";
import SkyDomeShader from  "./render/webgl/shaders/sky_dome";
import ParticlesShader from  "./render/webgl/shaders/particles";
import ChunkLODNodeOpaqueShader from  "./render/webgl/shaders/chunk_lod_node_opaque";
import WavgColorAccNoTextureShader from  "./render/webgl/shaders/wavg/wavg_color_acc_no_texture";
import WavgColorAccShader from  "./render/webgl/shaders/wavg/wavg_color_acc";
import WavgDepthAccShader from  "./render/webgl/shaders/wavg/wavg_depth_acc";
import WeightedAverageShader from  "./render/webgl/shaders/wavg/weighted_average";
import ShadowMapDepthShader from "./render/webgl/shaders/shadow_map/shadow_map_depth";
import ShadowMapPoissonShader from "./render/webgl/shaders/shadow_map/shadow_map_poisson";
import ShadowMapVarianceShader from "./render/webgl/shaders/shadow_map_variance/shadow_map_variance";
import ShadowMapVarianceCutOffShader from "./render/webgl/shaders/shadow_map_variance/shadow_map_variance_cut_off";
import ShadowMapBlurShader from "./render/webgl/shaders/shadow_map_variance/shadow_map_blur";
import AOShader from  "./render/webgl/shaders/ssao/ao";
import AOBlurShader from  "./render/webgl/shaders/ssao/ao_blur";
import AOGeometryShader from  "./render/webgl/shaders/ssao/ao_geometry";
import AONormalsShader from  "./render/webgl/shaders/ssao/ao_normals";
import AOMRTShader from  "./render/webgl/shaders/ssao/ao_mrt";
import DepthShader from "./render/webgl/shaders/depth/depth";
import AlphaDepthShader from "./render/webgl/shaders/depth/alpha_depth";
import BillboardDepthShader from "./render/webgl/shaders/depth/billboard_depth";
import LineDepthShader from "./render/webgl/shaders/depth/line_depth";
import PointDepthShader from "./render/webgl/shaders/depth/point_depth";
import ChunkLODDepthShader from "./render/webgl/shaders/depth/chunk_lod_depth";
import GrassShader from  "./render/webgl/shaders/environment/grass";
import FloorPlanShader from  "./render/webgl/shaders/environment/floor_plan";
import HUDShader from  "./render/webgl/shaders/environment/hud";
import ObjectIDShader from "./render/webgl/shaders/object_id/object_id";
import PointIDShader from "./render/webgl/shaders/object_id/point_id";
import LineIDShader from "./render/webgl/shaders/object_id/line_id";
import BillboardIDShader from "./render/webgl/shaders/object_id/billboard_id";
import PrimitiveIDShader from "./render/webgl/shaders/primitive_id/primitive_id";
import PointPrimitiveIDShader from "./render/webgl/shaders/primitive_id/point_primitive_id";
import LinePrimitiveIDShader from "./render/webgl/shaders/primitive_id/line_primitive_id";
import ShadowVolumeShader from "./render/webgl/shaders/shadow_volume/shadow_volume";
import Layer from "./render/webgl/layers/layer";
import ShadowMapLayer from "./render/webgl/layers/shadow_map_layer";
import SSAOLayer from "./render/webgl/layers/ssao_layer";
import ControlsLayer from "./render/webgl/layers/controls_layer";
import HUDLayer from "./render/webgl/layers/hud_layer";
import RenderGraphCanvas from "./render/canvas/render_graph";
import ModelStatistics from "./model_statistics";
import Messenger from "./messenger";
import {EEmbededElementTypes} from "./model/elements/factory";
import AlphaTransparency from "./render/webgl/nodes/bins/alpha_transparency_bin";
import Lines from "./render/webgl/nodes/bins/lines_bin";
import Opaque from "./render/webgl/nodes/bins/opaque_bin";
import OpaqueNoTexture from "./render/webgl/nodes/bins/opaque_no_texture_bin";
import Outlines from "./render/webgl/nodes/bins/outlines_bin";
import Poi from "./render/webgl/nodes/bins/poi_bin";
import Points from "./render/webgl/nodes/bins/points_bin";
import Transparent from "./render/webgl/nodes/bins/transparent_bin";
import TransparentNoTexture from "./render/webgl/nodes/bins/transparent_no_texture_bin";
import * as StorageUtils from "./storage/utils";
import {DataStorage} from "./storage/data_storage";
import DynamicAssetsManager from "./storage/dynamic_assets_manager";
import {FLOAT_PRECISION as FP} from "./math";
import Canvas from "./canvas";
import ShadowVolumesGenerator from "./utils/shadow_volumes/sv_generator";
import GlobeWorkerManager from "./utils/globe/globe_worker_manager";
import Projections from "./utils/projections";
import * as Debug from "./debug";

// Styles
import './scene.css';

export {
    Debug,
    Model,
    Asset,
    StateViewer,
    BoundingBox,
    Canvas,
    CanvasTextGenerator,
    RenderDocument,
    RenderElement,
    math,
    EEmbededElementTypes,
    EPartsTypes,
    LightingSettingsData,
    ConfigurationData,
    ZeropointSettings,
    Utils,
    Projections,
    SurfaceColor,
    LineProperties,
    PointProperties,
    RenderOption,
    LatLon,
    AbstractGeometry,
    GlobeWorkerManager,
    GlobeModel,
    Group,
    CameraAnimator,
    InterpolatorsFactory,
    Quaternion,
    LinearInterpolator,
    ViewMode,
    ViewModeSingle,
    ViewModeQuad,
    ViewModeStereo,
    ViewModeWebVR,
    ViewControls,
    Camera,
    ShadowVolumesGenerator,
    WebGLContext,
    Messenger,
    UPDATETYPES,
    PointCloud,
    MemoryManagement,
    RayIntersector,
    FlyControls,
    WalkControls,
    ProgressDispatchHelper,
    GLU,
    StorageUtils,
    EDataTypeType,
    DataStorage,
    DynamicAssetsManager
};
